import React from 'react'
import HotelIcon from '@mui/icons-material/Hotel'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

import FlightIcon from '@/src/assets/svgs/FlightIcon'
import FlightPlusHotelIcon from '@/src/assets/svgs/FlightPlusHotelIcon'

import { ToolbarLink, ToolbarPathMap } from '@/src/types/bottomToolbar'
import LanguageIcon from '@mui/icons-material/Language'
import { isFlyin } from '@/src/utils/generalUtils/isFlyin'
import { isCTAE } from '@/src/utils/generalUtils/isCTAE'
// Note: Labels are translation keys, not actual text
// They will be translated in the component using useTranslations('common')
export const COMMON_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'flight',
        value: 'flight',
        icon: React.createElement(FlightIcon),
        index: 0,
    },
    {
        label: 'hotel',
        value: 'hotel',
        icon: React.createElement(HotelIcon),
        index: 1,
    },

    {
        label: 'offers',
        value: 'offers',
        icon: React.createElement(LocalOfferOutlinedIcon),
        index: 3,
    },
    {
        label: 'account',
        value: 'account',
        icon: React.createElement(AccountCircleOutlinedIcon),
        index: 4,
    }
]

export const FLYIN_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'flightPlusHotel',
        value: 'fph',
        icon: React.createElement(FlightPlusHotelIcon),
        index: 2,
    },
]

export const CT_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'visa',
        value: 'visa',
        icon: React.createElement(LanguageIcon),
        index: 2
    }
]

export const TOOLBAR_PATH_MAP: ToolbarPathMap = {
    flight: '/',
    hotel: '/hotels',
    fph: '/fph',
    offers: '/offers',
    account: '/account',
    visa: '/visa',
}

// Function to get the appropriate toolbar links based on the brand.
// Uses brand check (isFlyin) rather than feature flags—FPH and Visa are brand-specific offerings.
export const fetchToolbarLinks = (): ToolbarLink[] => {
    let links: ToolbarLink[] = [...COMMON_TOOLBAR_LINKS]
    if (isFlyin()) {
        links = links.concat(FLYIN_TOOLBAR_LINKS)
    } else if (isCTAE()) {
        links = links.concat(CT_TOOLBAR_LINKS)
    }
    links.sort((a, b) => (a.index ?? links.length - 1) - (b.index ?? links.length - 1))
    return links
}
